<!--
  需求管理
    + 点击行进入需求详情，需求的主页
-->
<template>
  <div>
    <div class="panel_op">
      <el-button
        type="primary"
        size="small"
        @click="onCreate">
        发布需求
      </el-button>
      <el-select
        size="small"
        v-model="select"
        style="margin-left:10px;"
        clearable
        placeholder="请选择需求状态"
        @change="getPublisherRequire">
        <el-option
          v-for="item in globalVar.REQUIRE_STATUS_OPTIONS"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="panel_table">
      <el-table
        :data="tableData"
        :header-cell-style="headerCellStyle"
        v-loading="loading"
        @row-click="onDetail">
        <el-table-column
          label="需求标题"
          prop="title">
        </el-table-column>
        <!-- @todo 需求类型变化 -->
        <el-table-column
          label="需求类型"
          prop="serviceTypeName">
        </el-table-column>
        <el-table-column
          label="价格（元）"
          prop="budget">
        </el-table-column>
        <el-table-column
          label="需求截止时间"
          prop="endAt">
        </el-table-column>
        <el-table-column
          label="需求状态"
          prop="logicStatus">
          <template slot-scope="scope">
            {{ scope.row.logicStatus | findLabel(globalVar.REQUIRE_STATUS_OPTIONS) }}
          </template>
        </el-table-column>
        <el-table-column
          label="对接单位"
          prop="organizationName">
        </el-table-column>
        <el-table-column
          label="对接人"
          prop="username">
        </el-table-column>
        <el-table-column
          width="100px"
          label="操作">
          <template slot-scope="scope">
            <!-- 只有状态在已发布才能撤销 -->
            <el-button
              v-if="canRevoke(scope.row)"
              class="my-el-button-text-danger"
              type="text"
              @click.stop="onRevoke(scope.row)">
              撤销
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="panel_pagination tw-flex tw-justify-center tw-items-center">
      <el-pagination
        hide-on-single-page
        background
        @current-change="getPublisherRequire"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import globalVar from '@/configs/globalVar'

export default {
  data () {
    return {
      loading: false,
      select: '',
      tableData: [],
      // 分页对象
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    headerCellStyle () {
      return {
        backgroundColor: '#F7F8F9',
        color: '#909399',
        fontWeight: 'bold'
      }
    },
    canRevoke () {
      return (row) => {
        return row.logicStatus === globalVar.REQUIRE_STATUS_SUBMITTED
      }
    }
  },
  created () {
    this.getPublisherRequire()
  },
  methods: {
    // 获取需求列表
    getPublisherRequire () {
      this.loading = true
      api.getPublisherRequire({
        ...this.pagination,
        logicStatus: this.select
      }).then(res => {
        if (res.data.code === 0) {
          this.pagination.pageNum = res.data.data.currentPage
          this.pagination.total = res.data.data.total
          this.tableData = res.data.data.list
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      }).finally(() => {
        this.loading = false
      })
    },
    // 撤销
    onRevoke (row) {
      this.$msgbox({
        title: '确认',
        message: '确定要撤销此需求吗？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.revokeRequire(row, instance, done)
          } else {
            done()
          }
        }
      })
    },
    // 撤销需求
    revokeRequire (row, instance, done) {
      instance.confirmButtonLoading = true
      api.revokeMyRequire(row.id).then(res => {
        if (res.data.code === 0) {
          this.$message.success('操作成功')
          this.getPublisherRequire()
        } else {
          this.$message.error(res.data.message)
        }
        done()
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      }).finally(() => {
        instance.confirmButtonLoading = false
      })
    },

    /**
     * 发布需求
     *  + 非服务集成商用户只能发单个需求
     */
    onCreate () {
      const path = {
        [this.globalVar.USER_ROLE_0]: '/require-create',
        [this.globalVar.USER_ROLE_1]: '/require-create',
        [this.globalVar.USER_ROLE_2]: '/require-create/service-org'
      }[this.role]
      const { href } = this.$router.resolve({
        path
      })
      window.open(href, '_blank')
    },

    /**
     * 进入需求详情
     */
    onDetail (row) {
      window.open(`/require-detail-form/${row.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  width: 100%;
  min-width: 1030px;
  min-height: 100%;
  padding: 0 30px;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: auto;
  &_header {
    padding: 20px 0;
  }
  &_op {
    padding: 10px 0;
  }
  &_table {
    padding: 10px 0;
  }
  &_pagination {
    margin: 20px 0;
    height: 40px;
  }
}
</style>
